// @flow
import React, { useContext, useState } from 'react';
import { useFormikContext } from 'formik';
import { setFieldValueToGivenStringAndFieldTouchedToTrue } from '@src/formik-utils/utils';

import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import {
  CC_STARTER_COMMIT_NONE,
  CC_STARTER_COMMIT_TYPE_BACKEND_NAME,
  DEAL_TYPE_BACKEND_NAME,
  DEAL_TYPE_NEW_COMMIT,
  DEAL_TYPE_RENEWAL,
  IS_RENEWAL_AUTOMATION_LIVE,
  RATE_CARD_BACKEND_NAME,
} from '../../constants';
import { SelectField } from '../../formik-utils/FormFields';
import { EstimateContext } from '../../contexts/EstimateContext';
import { getDropdownOptionsFromArray } from '../../common-utils/utils';

import DealTypeChangeWarningModal from './DealTypeChangeWarningModal';

export const DealTypeContainer = () => {
  const { setFieldValue, setFieldTouched, initialValues } = useFormikContext();
  const estimateData = useContext(EstimateContext);
  const [isDealTypeChangeWarningModalOpen, setDealTypeChangeWarningModalOpen] = useState(false);
  const dealTypes = estimateData.commit_config.deal_types;
  const dealTypesOptions = getDropdownOptionsFromArray(dealTypes);
  const dealTypeConfig = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(DEAL_TYPE_BACKEND_NAME);

  return (
    <>
      <SelectField
        fieldDisplayName={dealTypeConfig.displayName}
        fieldName={dealTypeConfig.backendFieldName}
        onChange={async (_, newValue) => {
          // A package is only valid on a New Commit deal, so don't leave one behind.
          if (newValue !== DEAL_TYPE_NEW_COMMIT) {
            setFieldValue(CC_STARTER_COMMIT_TYPE_BACKEND_NAME, CC_STARTER_COMMIT_NONE);
          }
          const initialDealType = initialValues[DEAL_TYPE_BACKEND_NAME];
          const isDealTypeChangingFromRenewalToOther =
            initialDealType === DEAL_TYPE_RENEWAL && newValue !== DEAL_TYPE_RENEWAL;
          /*
            Existing behaviour is to clear RC when the deal type is changed.
            Case 1:  IS_RENEWAL_AUTOMATION_LIVE is false, then, we should simply default to the existing behaviour
            Case 2:  IS_RENEWAL_AUTOMATION_LIVE is true, then,
                  -    If the user is moving from Renewal -> New Commit, then we should ask for confirmation
                  -    Otherwise, if the user is moving from  New Commit  -> Renewal, we should simply default to the existing behaviour
             */
          if (IS_RENEWAL_AUTOMATION_LIVE && isDealTypeChangingFromRenewalToOther) {
            setDealTypeChangeWarningModalOpen(true);
          } else {
            await setFieldValueToGivenStringAndFieldTouchedToTrue(
              RATE_CARD_BACKEND_NAME,
              '',
              setFieldValue,
              setFieldTouched
            );
          }
        }}
        options={dealTypesOptions}
      />
      <DealTypeChangeWarningModal
        isOpen={isDealTypeChangeWarningModalOpen}
        setOpen={setDealTypeChangeWarningModalOpen}
      />
    </>
  );
};
